// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"238":"d8b9973a","449":"b75ad9b9","590":"8efc9943","617":"49a03919","781":"91c1cb62","891":"e9b77aa4"}[chunkId] + ".js";
};